module.exports = "<div class=\"body\" [ngClass]=\"{'no-padding':showHeader == false}\">\n  <app-progress-spinner></app-progress-spinner>\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/app.component.html
// module id = ../../../../../src-admin/app/app.component.html
// module chunks = main